import {NavLink} from 'react-router-dom';
import {Box, Breadcrumbs} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import config from '../config';

// Home is "/", which sends a signed-in person to this list. The console's copy
// pointed at /dashboard, a route Directory does not have.
export const IndexPageNavigation = () => {
    const breadcrumbs = [
        {title: I18n.get('Home'), href: '/'},
        {title: I18n.get(config.titles.plural)},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
